
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resetPassword/recoverPassword",
      function () {
        return require("private-next-pages/resetPassword/recoverPassword.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resetPassword/recoverPassword"])
      });
    }
  